'use client'

import { FileText } from 'react-feather'
import { useRouter, useTranslations } from '@/lib/next-shim'

import { GetMyInfosQuery } from '@/core/graphql/types'
import { ExpertiseCard } from '@/entities/expertise'

import { DashboardCarousel } from './DashboardCarousel'
import { DashboardSection } from './DashboardSection'

type ExpertisesProps = {
  expertises: GetMyInfosQuery['myInfos']['expertises']
}

export function Expertises({ expertises }: ExpertisesProps) {
  const t = useTranslations()

  return (
    <DashboardSection title={t('account.expertises.title')} count={expertises.length} viewAllHref="/account/expertises">
      <ExpertisesList expertises={expertises} />
    </DashboardSection>
  )
}

function ExpertisesList({ expertises }: { expertises: GetMyInfosQuery['myInfos']['expertises'] }) {
  const router = useRouter()
  const t = useTranslations()

  if (!expertises.length) {
    return (
      <div className="mx-5 flex flex-col items-center justify-center gap-3 rounded-2xl border border-dashed border-gray-200 bg-white px-6 py-10 text-center">
        <span className="flex h-12 w-12 items-center justify-center rounded-full bg-primary/10 text-primary">
          <FileText size={22} aria-hidden="true" />
        </span>
        <p className="text-sm font-semibold text-gray-900">{t('account.expertises.noExpertises')}</p>
      </div>
    )
  }

  return (
    <DashboardCarousel
      items={expertises}
      getItemKey={(expertise) => expertise._id}
      renderItem={(expertise) => <ExpertiseCard expertise={expertise} onClick={() => router.push(`/account/expertises/${expertise._id}`)} />}
    />
  )
}
